import { LastResultsResponse, TeamsStats } from "../interfaces/teamStats";
import { api } from "./api";

export const getTeamStats = async (id: number) => {
  const { data } = await api.get<TeamsStats>(`/api/v1/teams/${id}/stats`);
  return data;
};

export const getTeamResults = async (id: number, page: number) => {
  const { data } = await api.get<LastResultsResponse>(
    `/api/v1/teams/${id}/stats/results?page=${page}&page_size=10`
  );
  return data;
};

export const exportTeamResults = async (id: number) => {
  const response = await api.get(`/api/v1/teams/${id}/stats/results/export/`, {
    responseType: "blob",
  });

  const contentDisposition = response.headers["content-disposition"];

  let filename = "reporte_equipo.xlsx";

  // Extraer nombre del archivo si viene en content-disposition
  const match = contentDisposition?.match(/filename="?(.+?)"?$/);
  if (match?.[1]) {
    filename = decodeURIComponent(match[1]);
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));

  return { filename, url }
};
